// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__dvPqI","brand":"Logo_brand__65ttm","label":"Logo_label__KysN9","productName":"Logo_productName__Aagt5"};